import React from 'react';
import { Link } from 'react-router-dom';

const SideMenuBar = () => {
  const menuItems = [
    { text: 'Dashboard', icon: 'fas fa-fw fa-tachometer-alt', path: '/' },
    { text: '나의 할일 (MyWork)', icon: 'fas fa-fw fa-tasks', path: '/my-work' },
    { text: '큐티 본문 일괄 입력', icon: 'fas fa-fw fa-bible', path: '/qt/DailyScriptureBulkUpload' },
    { text: '큐티 본문 리스트', icon: 'fas fa-fw fa-list', path: '/qt/DailyScriptureList' },
    { text: '동영상 관리', icon: 'fas fa-fw fa-video', path: '/qt/videos' },
    { text: '음성 파일 관리', icon: 'fas fa-fw fa-volume-up', path: '/qt/audios' },
    { text: '퀴즈 관리', icon: 'fas fa-fw fa-question-circle', path: '/quiz' },
    { text: '성경공부', icon: 'fas fa-fw fa-book-open', path: '/bible-study' },
    { text: '성경 구절 관리', icon: 'fas fa-fw fa-book', path: '/bible' },
    { text: '성경 JSON 업로드', icon: 'fas fa-fw fa-file-upload', path: '/bible-json-upload' },
    { text: '가정예배', icon: 'fas fa-fw fa-home', path: '/family-worship' },
    { text: '앱 푸시 관리', icon: 'fas fa-fw fa-bell', path: '/push' },
    { text: '이미지 관리', icon: 'fas fa-fw fa-image', path: '/image-management' },
    { text: '광고 카드 관리', icon: 'fas fa-fw fa-ad', path: '/ad-cards' },
    { text: '공통 메시지 관리', icon: 'fas fa-fw fa-file-alt', path: '/common-messages' },
    { text: '공지사항 관리', icon: 'fas fa-fw fa-bullhorn', path: '/notices' },
    { text: '1대1 문의 관리', icon: 'fas fa-fw fa-comments', path: '/inquiries' },
    { text: '사용자 관리', icon: 'fas fa-fw fa-users', path: '/users' },
  ];

  return (
    <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

      <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/">
        <div className="sidebar-brand-icon rotate-n-15">
          <i className="fas fa-laugh-wink"></i>
        </div>
        <div className="sidebar-brand-text mx-3">MISSION QT ADMIN</div>
      </Link>

      <hr className="sidebar-divider my-0" />

      <div className="sidebar-heading">
        데이터 관리
      </div>

      {menuItems.map((item, index) => (
        <li className="nav-item" key={item.text}>
          <Link className="nav-link" to={item.path}>
            <i className={item.icon}></i>
            <span>{item.text}</span>
          </Link>
        </li>
      ))}

      <hr className="sidebar-divider d-none d-md-block" />

      <div className="text-center d-none d-md-inline">
        <button className="rounded-circle border-0" id="sidebarToggle"></button>
      </div>

    </ul>
  );
};

export default SideMenuBar;